import { useQuery } from '@tanstack/react-query';

import luxPlusPricingConfigService from '~/services/cruises/LuxPlusPricingConfigService';

import { luxPlusPricingConfigQueryKeys } from './luxPlusPricingConfigQueryKeys';

export function useGetLuxPlusPricingConfigs(vendorId: string | undefined) {
  return useQuery({
    queryKey: luxPlusPricingConfigQueryKeys.list(vendorId),
    queryFn: () => luxPlusPricingConfigService.list(vendorId),
    enabled: !!vendorId,
  });
}
